import { useEffect, useState } from "react";
import { BellRinging, BellSimpleSlash, PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { enablePush, isPushEnabled, pushSupported } from "../lib/push";

export function PushToggle() {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    isPushEnabled().then(setEnabled);
  }, []);

  const sendTest = async () => {
    setTesting(true);
    try {
      await api.post("/push/test");
      toast.success("Test-Push gesendet – gleich sollte die Mitteilung erscheinen.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Test-Push fehlgeschlagen.");
    } finally {
      setTesting(false);
    }
  };

  if (enabled) {
    return (
      <div className="flex items-center gap-2">
        <div
          data-testid="push-enabled"
          className="flex h-10 items-center gap-1.5 rounded-full bg-[#276749]/10 px-3 text-xs font-semibold text-[#276749]"
        >
          <BellRinging size={16} weight="fill" /> Push aktiv
        </div>
        <button
          data-testid="test-push-btn"
          onClick={sendTest}
          disabled={testing}
          className="flex h-10 items-center gap-1.5 rounded-full border border-[#C5A059] px-3 text-xs font-semibold text-[#8a6d2f] transition-colors hover:bg-[#FBF8F1] disabled:opacity-50"
        >
          <PaperPlaneTilt size={16} weight="fill" /> {testing ? "..." : "Test"}
        </button>
      </div>
    );
  }

  if (!pushSupported()) return null;

  const activate = async () => {
    setBusy(true);
    try {
      await enablePush();
      setEnabled(true);
      toast.success("Web-Push aktiviert – du erhältst jetzt Benachrichtigungen.");
    } catch (e) {
      toast.error(e.message || "Konnte Push nicht aktivieren.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="enable-push-btn"
      onClick={activate}
      disabled={busy}
      className="flex h-10 items-center gap-1.5 rounded-full border border-[#E2E8F0] px-3 text-xs font-semibold text-[#0A1128] transition-colors hover:border-[#C5A059] disabled:opacity-50"
    >
      <BellSimpleSlash size={16} /> {busy ? "..." : "Push aktivieren"}
    </button>
  );
}
